import { FeedingReportsService } from "../../routes/services/feeding-reports.service";
import { PermissionsService } from "../../routes/services/permissions.service";
import { StorageService } from "../../routes/services/storage.service";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { FeedersService } from "../../routes/services/feeder.service";
import { FramesService } from "../../routes/services/frames.service";
import { GlobalFunction } from "../../routes/services/globalFuntion";
import { PondService } from "../../routes/services/pond.service";
import { Subscription } from "rxjs";
import * as moment from "moment";
import {
  EventEmitter,
  HostListener,
  Component,
  ViewChild,
  OnInit,
  Output,
  Input
} from "@angular/core";

@Component({
  selector: "app-ration-modal",
  templateUrl: "./ration-modal.component.html",
  styleUrls: ["./ration-modal.component.scss"],
  providers: [NgbModalConfig, NgbModal]
})
export class RationModalComponent implements OnInit {
  @Output("closed") closed = new EventEmitter();
  @ViewChild("modalRation") public modalRation;

  feederAlert: any;
  @Input() feederID: any;
  feeder;
  socketSubsciption: Subscription;
  @Input() pond_id: any;

  options = {};
  dataGraph: any = [];
  labelsGraph = ["January", "February", "March", "April", "May", "June"];
  optionsGraph: any;

  lineColors = [
    {
      borderColor: "rgba(0,0,0,0.1)",
      backgroundColor: "rgba(207, 0, 15, 0.09)"
    }
  ];

  view: "diet" | "food" | "speed" | "" = "";
  permissions = {
    view_virtual_weight: true
  };

  /** true cuando el estanque lo alimenta administracion (Pond.feeding_by_admin). */
  feedingByAdmin = false;

  constructor(
    public feedingReportService: FeedingReportsService,
    public permissionsService: PermissionsService,
    public globalFunction: GlobalFunction,
    public storageService: StorageService,
    public feederService: FeedersService,
    public framesService: FramesService,
    public pondService: PondService,
    private modalService: NgbModal,
    config: NgbModalConfig
  ) {
    config.backdrop = "static";
    config.keyboard = false;
    config.size = "xl";
    config.centered = true;
    config.animation = false;
  }
  /* para saber cuando esta inicializado el componente y poder validar */
  initialValue = false;
  modalRef: null | any = null;
  close = false;

  loading_data_pond = true;

  @HostListener("document:click", ["$event"])
  onClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    const myDiv: any = document.querySelector(`[id='ration-modal']`);
    const validateClassSwall = () => {
      const views = [
        "swal2-header",
        "swal2-container",
        "swal2-cancel",
        "swal2-popup",
        "swal2-title",
        "swal2-html-container",
        "swal2-icon-content",
        "swal2-icon",
        "swal2-confirm",
        "swal2-actions"
      ];
      const some = views.some((item) => targetElement.classList.contains(item));
      return some;
    };

    if (
      this.initialValue &&
      targetElement.id !== "menu-alert-ponds" &&
      targetElement.id !== "check-feeder" &&
      this.modalRef !== null &&
      !validateClassSwall() &&
      myDiv &&
      !myDiv.contains(targetElement) &&
      !this.close
    ) {
      this.closeModal();
      event.stopPropagation();
    }
  }

  openModal = async () => {
    const ref = await this.modalService.open(this.modalRation);
    await ref.shown.subscribe(() => {
      this.modalRef = ref;
      setTimeout(() => {
        this.initialValue = true;
      }, 100);
    });
  };

  closeModal() {
    this.modalService.dismissAll();
    this.modalRef = null;

    this.closed.emit("");
  }

  ngOnDestroy(): void {
    this.socketSubsciption.unsubscribe();
  }
  ngAfterViewInit(): void {
    this.openModal();
  }

  ngOnInit(): void {
    const validate = (prop) => {
      return this.permissionsService.validatePermissionsExistSubclient(prop);
    };
    const validateClient = (prop) => {
      return this.permissionsService.validatePermissionsExistClient(prop);
    };
    this.permissions = {
      view_virtual_weight: validateClient("view_virtual_weight") && validate("view_virtual_weight")
    };
    this.loadRationData();
    this.pond_id && this.getFeedingByAdmin();
    this.socketSubsciption = this.storageService.watchStorage("socket").subscribe((msg: any) => {
      if (msg) {
        this.getFeeder(msg);
      }
    });
  }
  getFeeder = async (msg) => {
    if (msg.data && msg.data.mac === this.feeder.mac) {
      if (msg.data.type === "SPEED_RESPONSE") {
        const { high_speed, low_speed, speed, speed_enabled, orbital_enabled } = msg.data;
        const validateSpeedMode = () => {
          if (speed_enabled) return 1;
          if (orbital_enabled) return 2;
          if (!speed_enabled && !orbital_enabled) return 0;
        };
        this.feeder = {
          ...this.feeder,
          status_high_speed: high_speed,
          status_low_speed: low_speed,
          status_speed: speed,
          status_speed_mode: validateSpeedMode()
        };
      }
    }
  };

  getSpeed() {
    this.framesService.individualFrames(this.feeder.id, "request_speed").subscribe((resp) => {});
  }
  /**
   * Carga primero el equipo (con su ultimo reporte) y despues el reporte del
   * estanque, para que la grafica de dieta ya use la racion del equipo.
   * @returns void
   */
  loadRationData = async () => {
    if (this.feederID) {
      await this.getFeedingReport(this.feederID);
    }
    if (this.pond_id) {
      this.getPondData();
    }
  };

  /**
   * Indica si el equipo trae su propio ultimo reporte de alimentacion
   * (Feeder.last_feeding_report con id).
   * @returns true cuando la racion se debe mostrar por equipo.
   */
  hasFeederReport(): boolean {
    return !!(this.feeder && this.feeder.last_feeding_report && this.feeder.last_feeding_report.id);
  }

  /**
   * Kilogramos de la racion a mostrar: los del ultimo reporte del equipo si
   * existe, si no los del ultimo reporte del estanque.
   * @returns Kilogramos de la racion, o 0 si no hay reporte.
   */
  getRationKgs(): number {
    if (this.hasFeederReport()) {
      return this.feeder.last_feeding_report.kgs_fed;
    }
    return this.feederAlert ? this.feederAlert.kgs_fed : 0;
  }

  /**
   * Fecha de envio de la racion a mostrar: la del ultimo reporte del equipo si
   * existe, si no la del ultimo reporte del estanque.
   * @returns Fecha de creacion del reporte, o null si no hay reporte.
   */
  getRationSentDate(): string | null {
    if (this.hasFeederReport()) {
      return this.feeder.last_feeding_report.created_date;
    }
    return this.feederAlert ? this.feederAlert.created_date : null;
  }

  /**
   * Racion por equipo: kgs del ultimo reporte del equipo repartidos entre las
   * tolvas activas del estanque.
   * @param kgs_fed Kilogramos a repartir entre las tolvas activas.
   * @returns Kilogramos por equipo, o 0 si no hay datos para calcular las tolvas activas.
   */
  getFeederRationPerUnit(kgs_fed: number): number {
    if (!this.hasFeederReport() || !this.feederAlert || !this.feeder.feeding_details) {
      return 0;
    }
    const active_feeders = this.getActiveFeeders(
      this.feederAlert.kgs_fed,
      this.feeder.feeding_details.feeder_ration
    );
    if (!active_feeders) {
      return 0;
    }
    return kgs_fed / active_feeders;
  }

  getFeedingReport = async (feeder_id: number) => {
    const fields = [
      "id",
      "name",
      "feeding_details",
      "last_feeding_report",
      "dispenser",
      "virtual_weight",
      "status_version",
      "status_speed_mode",
      "view_mode_speed",
      "status_speed",
      "status_low_speed",
      "status_high_speed"
    ];
    let feeder = await this.feederService.GetFeederID(feeder_id, `?fields=${fields}`).toPromise();

    if (feeder) {
      this.feeder = feeder;
      this.feeder.view_speed = false;
      const validateView_mode_speed = () => {
        const { status_speed_mode } = feeder;
        if (status_speed_mode === 1) return "normal";
        return "orbital";
      };
      this.feeder.view_mode_speed = validateView_mode_speed();
    }
  };
  getPondData = async () => {
    const fields_feeding = ["id", "diet", "food", "kgs_fed", "planting", "user", "created_date"];
    this.loading_data_pond = true;

    try {
      const query = `?pond_id=${this.pond_id}&page=1&page_size=1&ordering=-date&type=0&projection=false&fields=${fields_feeding}`;
      let reports = await this.feedingReportService.getFeedingReports(query).toPromise();

      if (reports) {
        this.loading_data_pond = false;

        this.feederAlert = reports.results.length > 0 ? reports.results[0] : "";
        if (this.feederAlert.diet) {
          this.setData(this.feederAlert.diet);
        }
      }
    } catch (error) {}
    if (!this.pond_id) {
      this.feederAlert = "";
      this.loading_data_pond = false;
    }
  };

  /**
   * Obtiene si el estanque lo alimenta administracion, para mostrar solo las
   * tarjetas de Envio/Alimento/Racion y ocultar el resto (grafica de dieta,
   * peso virtual, velocidad, "esta hora" y los botones de esas vistas).
   * @returns void
   */
  getFeedingByAdmin = async () => {
    try {
      const pond = await this.pondService
        .getPonds("?fields=id,feeding_by_admin", this.pond_id)
        .toPromise();
      this.feedingByAdmin = !!(pond && pond.feeding_by_admin);
    } catch (error) {}
  };

  /**
   * Indica si se deben ocultar la grafica de dieta, peso virtual, velocidad,
   * "esta hora" y sus botones. Solo aplica al cliente en un estanque manejado
   * por administracion: el admin ve todo, aunque este operando en modo
   * cliente.
   * @returns true cuando esas vistas deben ocultarse.
   */
  hideAdminManagedViews(): boolean {
    return this.feedingByAdmin && !this.storageService.validateSoloAdmin();
  }

  setData(value) {
    this.view = "diet";
    const { labels, data, options } = this.constructDataGraph(value);

    this.labelsGraph = labels;
    this.dataGraph = data;
    this.optionsGraph = options;
  }

  constructDataGraph(value) {
    const Labels = Array.from({ length: 24 }, (_, i) => `${i}:00`);

    const percentages = value.percentages.map((item) => Number(item) * 100);
    const all_grams = value.percentages.map((item) =>
      (Number(item) * this.getRationKgs()).toFixed(2)
    );
    const Data = [
      {
        data: percentages,
        name: "Porcentaje",
        type: "bar",
        color: "#30646c",
        yAxisIndex: 0
      },
      {
        data: all_grams,
        name: "Kilogramos a alimentar",
        type: "line",
        color: "#1e983b",
        yAxisIndex: 1,
        smooth: true
      }
    ];

    return {
      labels: Labels,
      data: Data,
      options: {
        legend: {
          data: ["Porcentaje", "Kilogramos a alimentar"],
          top: 0
        },
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            const index = params[0]?.dataIndex ?? 0;
            const interval = value.intervals?.[index] ?? "N/A";
            const amount_shoots = 60 / interval;

            const porcentaje = params.find((p) => p.seriesName === "Porcentaje")?.data.toFixed(2);
            const kilograms = params.find((p) => p.seriesName === "Kilogramos a alimentar")?.data;

            return `
            Hora: <b>${Labels[index]}</b><br/>
            Porcentaje: <b>${porcentaje}%</b><br/>
            Kilogramos: <b>${kilograms} kg</b><br/>
            Intervalo entre disparo: <b>${interval}</b><br/>
            Cantidad de disparos: <b>${amount_shoots}</b>
          `;
          }
        },
        xAxis: {
          type: "category",
          data: Labels,
          axisPointer: { type: "shadow" }
        },
        yAxis: [
          {
            type: "value",
            name: "Porcentaje",
            min: 0,
            axisLabel: { formatter: "{value} %" }
          },
          {
            type: "value",
            name: "Kilogramos a alimentar",
            position: "right",
            min: 0,
            axisLabel: { formatter: "{value} kgs" }
          }
        ],
        series: Data
      }
    };
  }

  validateVersionSpeed(feeder) {
    if (feeder) {
      return (
        this.globalFunction.validateVersion(feeder, 0.5) && this.storageService.validateSoloAdmin()
      );
    }
    return false;
  }
  validateFeedRate = (feeder_ration: number, percentage: number) => {
    try {
      const percent = percentage / 100;
      const total = feeder_ration * percent;
      return total;
    } catch (error) {
      return 0;
    }
  };

  /**
   * Calcula la cantidad de tolvas activas a partir de los kgs alimentados y la racion por tolva.
   * @param kgs_fed Kilogramos alimentados totales.
   * @param feeder_ration Racion asignada por tolva.
   * @returns Cantidad de tolvas activas con 2 decimales, o 0 si los datos no son validos.
   */
  getActiveFeeders(kgs_fed: number, feeder_ration: number): number {
    if (!kgs_fed || !feeder_ration) {
      return 0;
    }
    return Number(kgs_fed / feeder_ration);
  }

  /**
   * Calcula los kilogramos que le corresponden a cada tolva en la hora actual,
   * repartiendo los kgs de la hora entre las tolvas activas.
   * @param kgs_fed Kilogramos alimentados totales.
   * @param percentage Porcentaje de la dieta asignado a la hora actual.
   * @param feeder_ration Racion asignada por tolva.
   * @returns Kilogramos por tolva, o 0 si los datos no son validos.
   */
  getKgsPerFeeder(kgs_fed: number, percentage: number, feeder_ration: number): number {
    const active_feeders = this.getActiveFeeders(kgs_fed, feeder_ration);
    if (!active_feeders) {
      return 0;
    }
    return this.validateFeedRate(kgs_fed, percentage) / active_feeders;
  }

  validatingAdmin(selectedDiet: any) {
    if (!selectedDiet) {
      return true;
    }
    if (this.globalFunction.validateSoloAdmin()) {
      return true;
    }
    if (selectedDiet.id == 1366) {
      return false;
    }
    return true;
  }
}
